import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { ContractManagementResponse } from 'src/apis/contract-management/types';
import { Sidebar } from 'src/components/layout/sidebar';
import { ExternalLink, Link } from 'src/components/navigation/link';
import { Successful } from 'src/hooks/use-axios';
import { ShipperResponse } from 'src/pages/shippers/details/information/types';
import { ShipperPlatformIdsRequest } from 'src/pages/shippers/use-shipper-platform-ids';

type ShipperInformationSidebarProps = {
  contractManagement?: ContractManagementResponse;
  contractManagementShipper?: ShipperResponse | '';
  shipperPlatformIds: Successful<ShipperPlatformIdsRequest>;
};

export const ShipperInformationSidebar: FC<ShipperInformationSidebarProps> = ({
  contractManagement,
  contractManagementShipper,
  shipperPlatformIds,
}) => {
  const shipperRefId = shipperPlatformIds.response.data.referenceId.toString();
  const { shipperUuid } = useParams<{ shipperUuid: string }>();
  return (
    <Sidebar>
      <Link
        to={`/dashboard/shippers/${shipperUuid}/information`}
        mode="sidebar"
      >
        Shipper Info
      </Link>

      <ExternalLink
        href={`${PRISMA_CONFIG.oldFrontendUrl}/#/shippers/details/${shipperRefId}/credit-limits`}
        mode="sidebar"
      >
        Credit Limits
      </ExternalLink>

      <ExternalLink
        href={`${PRISMA_CONFIG.oldFrontendUrl}/#/shippers/details/${shipperRefId}/contact-details`}
        mode="sidebar"
      >
        Contact Details
      </ExternalLink>

      <Link to={`/dashboard/shippers/${shipperUuid}/documents`} mode="sidebar">
        Documents
      </Link>

      {contractManagement?._links.contracts && (
        <Link
          to={`/dashboard/shippers/${shipperUuid}/contracts`}
          mode="sidebar"
        >
          Contracts
        </Link>
      )}
      {contractManagementShipper &&
        contractManagementShipper?._links.getFinancialSecurities && (
          <Link
            to={`/dashboard/shippers/${shipperUuid}/financial-securities`}
            mode="sidebar"
          >
            Financial Securities
          </Link>
        )}
    </Sidebar>
  );
};
